import React from 'react';
import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';
import { useAppSelector } from '../../../stores/redux.store';
import { useRegisterComponent } from '../../orchestrator';
import { useMarketingConsentContext } from '../contexts/LoginMarketingConsentContext';
import MarketingConsentCheckbox from '../../../components/MarketingConsentCheckbox';

const StyledMarketingConsentWrapper = styled.div`
  padding-top: ${gridSize() * 2}px;
`;

type Props = {
  /**
   * Determines which redux slice the hook selects from:
   *   'v1' -> `state.login` (this is the default if unspecified)
   *   'v2' -> `state.loginV2`
   *
   * Consumer supplies this based on whether the login page targets `POST /check-username` or `POST
   * /v2/check-username`, respectively.
   *
   * The option is there to support migration from the former to the latter.
   *
   * It may be removed when the migration is complete across all login page implemenations.
   *
   * See README-login-v2.md for details.
   */
  loginStateSource?: 'v1' | 'v2';
};

export const LoginMarketingConsent = ({ loginStateSource = 'v1' }: Props) => {
  useRegisterComponent(LoginMarketingConsent.name);

  const config = useAppSelector(state => state.marketingConsent?.config);
  const isUsernameChecked = useAppSelector(state =>
    loginStateSource === 'v2' ? state.loginV2?.isUsernameChecked : state.login?.isUsernameChecked
  );

  const { setMarketingConsent } = useMarketingConsentContext();

  if (!isUsernameChecked) {
    return null;
  }

  return (
    <StyledMarketingConsentWrapper>
      <MarketingConsentCheckbox config={config} onConsentChange={setMarketingConsent} />
    </StyledMarketingConsentWrapper>
  );
};
